import { render, staticRenderFns } from "./HeaderNavigation.vue?vue&type=template&id=37e87e84&scoped=true"
import script from "./HeaderNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderNavigation.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HeaderNavigation.vue?vue&type=style&index=0&id=37e87e84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e87e84",
  null
  
)

export default component.exports